import { Action } from '@ngrx/store';

export const LOAD_CONTACTS = '[Contact] Load contacts...';
export const LOAD_CONTACTS_SUCCESS = '[Contact] Load contacts success...';
export const LOAD_CONTACTS_ERROR = '[Contact] Load contacts error...';
export const LOAD_CONTACT = '[Contact] Load contact...';
export const LOAD_CONTACT_SUCCESS = '[Contact] Load contact success...';
export const LOAD_CONTACT_ERROR = '[Contact] Load contact error...';
export const OPEN_TAB = '[Contact] open tab...';
export const CLOSE_TAB = '[Contact] close tab...';
export const SAVE_CONTACT = '[Contact] Save contact...';
export const SAVE_CONTACT_SUCCESS = '[Contact] Save contact success...';
export const SAVE_CONTACT_ERROR = '[Contact] Save contact error...';
export const ADD_CONTACT = '[Contact] Add contact...';



export class LoadContactsAction implements Action {
    readonly type = LOAD_CONTACTS;
    constructor(
		public sortField: string,
		public sortOrder: number,
		public filters: any,
		public first: number,
		public rows: number		
    ) {    	
    }    
}

export class LoadContactsSuccessAction implements Action {
    readonly type = LOAD_CONTACTS_SUCCESS;
    constructor ( public contacts: any[], public totalCount: number ) {}    
}

export class LoadContactsErrorAction implements Action {
    readonly type = LOAD_CONTACTS_ERROR;
    constructor ( public error: any ) {}    
}


export class LoadContactAction implements Action {
    readonly type = LOAD_CONTACT;
    constructor(
        public id: number,        
    ) {        
    }    
}

export class LoadContactSuccessAction implements Action {
    readonly type = LOAD_CONTACT_SUCCESS;
    constructor ( public contact: any) {}    
}

export class LoadContactErrorAction implements Action {
    readonly type = LOAD_CONTACT_ERROR;
    constructor ( public error: any ) {}    
}

export class CloseTabAction implements Action {
    readonly type = CLOSE_TAB;
    constructor ( public id: number ) {}    
}

export class OpenTabAction implements Action {
    readonly type = OPEN_TAB;
    constructor ( public id: number ) {}    
}


export class SaveContactAction implements Action {
    readonly type = SAVE_CONTACT;
    constructor(
        public contact: any,        
    ) {        
    }    
}

export class SaveContactSuccessAction implements Action {
    readonly type = SAVE_CONTACT_SUCCESS;
    constructor (        public id: number, public contact: any) {}    
}

export class SaveContactErrorAction implements Action {
    readonly type = SAVE_CONTACT_ERROR;
    constructor ( public id:number,  public error: any ) {}    
}

export class AddContactAction implements Action {
    readonly type = ADD_CONTACT;
    constructor ( ) {}    
}


export type contactActions = LoadContactsAction | LoadContactsSuccessAction |
LoadContactsErrorAction | LoadContactAction | LoadContactSuccessAction |
LoadContactErrorAction | OpenTabAction | CloseTabAction | SaveContactAction | SaveContactSuccessAction |
SaveContactErrorAction | AddContactAction;
